import React, {ReactNode} from 'react';
import Form from '@clayui/form';

type BaseWarningProps = {
   children: ReactNode
};

export default function BaseWarning (props: BaseWarningProps) {
    return (
        <Form.FeedbackGroup>
            <Form.FeedbackItem>
                {props.children}
            </Form.FeedbackItem>
        </Form.FeedbackGroup>
    );
}

